const buildEditableNode = (nodeName, attributes, content, propertyPath) => {
  // Sometimes people manage to put html in their text. Remove text if that happens
  if (content.includes('data-medium-editor-element="true"')) {
    content = ''
  }
  return `<${nodeName} ${attributes} tabindex="0">${content}<span data-prop="${propertyPath}" class="ck-editable-element" data-editable="basic" style="display:none;"></span></${nodeName}>`
}

export default buildEditableNode
